import React, { Component, PropTypes }from 'react';
import { Button } from 'reactstrap';

import NavBar from './NavBar';
import NavLink from './NavLink';

class CopyAssignmentLinks extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { dropbox, onClickSubmit } = this.props;

        return(
            <NavBar
                className="copy-assignment-links navbar navbar-toggleable-md navbar-light bg-faded fixed-top navbar-sub"
            >
                <NavLink
                    to={`/?expand=${dropbox.id}`}
                    className="btn btn-outline-primary btn-md"
                    side="left"
                    display
                    key="course"
                >
                    Exit To Course <i className={"fa fa-chevron-circle-left"}/>
                </NavLink>
                <NavLink
                    to="submit"
                    className=""
                    side="right"
                    display
                    key="submit"
                >
                    <Button
                        className="btn btn-primary btn-md"
                        type="button"
                        onClick={onClickSubmit}
                        size="md"
                        color="success"
                        title="Submit"
                    >
                    Submit <i className="fa fa-files-o" aria-hidden="true"/>
                    </Button>
                </NavLink>
            </NavBar>
        );
    }
}

CopyAssignmentLinks.propTypes = {
    dropbox: PropTypes.object.isRequired,
    onClickSubmit: PropTypes.func.isRequired
};

export default CopyAssignmentLinks;



/** WEBPACK FOOTER **
 ** ./src/components/CopyAssignmentLinks.js
 **/